export const FEATURES = {
  SHOW_PLATFORM_PICKER_FOR_LINKS: true,
  STATISTICS: country => country === 'pl',
  APP_CONFIG: {
    ARTICLES_SECTION_SETTINGS: country => country === 'pl' || country === 'cz',
    MOBILE_WHATS_NEW_BANNER: country => country === 'pl',
    SEARCH_SETTINGS: () => country =>
      country === 'pl' ||
      country === 'cz' ||
      country === 'sk' ||
      country === 'ro' ||
      country === 'ua' ||
      country === 'lt',
    KEYWORDS: () => true,
    MOBILE_RECOMMENDATION_TYPE: country => country === 'pl',
    MOBILE_RECOMMENDATION_HIGHLIGHTED_LEAFLET_ID: country => country === 'pl',
    MOBILE_RECOMMENDATION_CUSTOM_TYPE_LINK: country => country === 'pl',
    MOBILE_RECOMMENDATION_CUSTOM_TYPE_PICTURE_URL: country => country === 'pl',
    MOBILE_ONBOARDING: country => country === 'pl',
    WEB_POPULAR_CITIES: () => true,
    WEB_LEAFLET_VIEW: () => true,
    WEB_POPULAR_STORES: () => true,
    WEB_MEGA_MENU: country => country === 'pl',
    WEB_FOOTER_LINKS: country => country === 'pl',
    WEB_RECIPES: country => country === 'pl',
    AI_CONFIGURATION: () => true
  }
}
